<template>

  <div id="load-screen" :style="notFullScreen?' position:relative; z-index: 999':''">
    <div id="wrapper" :style="notFullScreen? 'margin:60px auto; position:relative;': ''">
      <!--   <div id="img">
            <img src="../../static/img/logo-weld-border.png" style="width: 100%; height: auto"/>
        </div> -->
        <div class="spinner circles">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'load-screen',
  props: ['notFullScreen']
}
</script>

<style scoped lang="scss">
@import '../assets/scss/variables.scss';
#load-screen{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: white;
    z-index: 9999;
}
#load-screen #wrapper{
    position: fixed;
    margin: auto;
    top:0;
    bottom: 0;
    left:0;
    right: 0;
    height: 120px;
    width: 120px;
}
#img{
    text-align: center;
}
.spinner{
     width:50px;
     height:50px;
     margin:30px auto;
     position:relative;
     -webkit-animation: rotateit 1.3s linear infinite;
     -moz-animation: rotateit 1.3s linear infinite;
     animation: rotateit 1.3s linear infinite;
}
@-webkit-keyframes rotateit {
     from {
          -webkit-transform: rotate(360deg);
     }
     to {
          -webkit-transform: rotate(0deg);
     }
}
@-moz-keyframes rotateit {
     from {
          -moz-transform: rotate(360deg);
     }
     to {
          -moz-transform: rotate(0deg);
     }
}
@keyframes rotateit {
     from {
          transform: rotate(360deg);
     }
     to {
          transform: rotate(0deg);
     }
}
/*=======================================================
 * Circles
 *======================================================*/
.spinner.circles div{
     width: 10px;
     height: 10px;
     border-radius:50%;
     background: $k-turq;
     position: absolute;
     top: 18px;
     left: 23px;
}
.spinner.circles div:nth-child(1){
     -webkit-transform: rotate(0deg) translate(0, -25px) scale(1.4);
     -moz-transform: rotate(0deg) translate(0, -25px) scale(1.4);
     transform: rotate(0deg) translate(0, -25px) scale(1.4);
}
.spinner.circles div:nth-child(2){
     -webkit-transform: rotate(45deg) translate(0, -25px) scale(1.2);
     -moz-transform: rotate(45deg) translate(0, -25px) scale(1.2);
     transform: rotate(45deg) translate(0, -25px) scale(1.2);
     opacity:0.8;
}
.spinner.circles div:nth-child(3){
     -webkit-transform: rotate(90deg) translate(0, -25px) scale(1.1);
     -moz-transform: rotate(90deg) translate(0, -25px) scale(1.1);
     transform: rotate(90deg) translate(0, -25px) scale(1.1);
     opacity:0.7;
}
.spinner.circles div:nth-child(4){
     -webkit-transform: rotate(135deg) translate(0, -25px) scale(1);
     -moz-transform: rotate(135deg) translate(0, -25px) scale(0.9);
     transform: rotate(135deg) translate(0, -25px) scale(0.9);
     opacity:0.6;
}
.spinner.circles div:nth-child(5){
     -webkit-transform: rotate(180deg) translate(0, -25px) scale(0.8);
     -moz-transform: rotate(180deg) translate(0, -25px) scale(0.7);
     transform: rotate(180deg) translate(0, -25px) scale(0.7);
     opacity:0.5;
}
.spinner.circles div:nth-child(6){
     -webkit-transform: rotate(225deg) translate(0, -25px) scale(0.6);
     -moz-transform: rotate(225deg) translate(0, -25px) scale(0.5);
     transform: rotate(225deg) translate(0, -25px) scale(0.5);
     opacity:0.4;
}
.spinner.circles div:nth-child(7){
     -webkit-transform: rotate(270deg) translate(0, -25px) scale(0.4);
     -moz-transform: rotate(270deg) translate(0, -25px) scale(0.3);
     transform: rotate(270deg) translate(0, -25px) scale(0.3);
     opacity:0.3;
}
.spinner.circles div:nth-child(8){
     -webkit-transform: rotate(315deg) translate(0, -25px) scale(0.2);
     -moz-transform: rotate(315deg) translate(0, -25px) scale(0.1);
     transform: rotate(315deg) translate(0, -25px) scale(0.1);
     opacity:0.2;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadScreen.vue